<template>
  <div id="page-wrapper" style="height:100%">
    <div class="row page-titles" style="margin-bottom:0px">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('files.title') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.admin') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('files.title') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid" style="height:100%; padding:0; margin:0">
      <el-container style="height:100%;">
        <el-aside width="300px">
          <el-input
          :placeholder="$t('files.filter')"
          v-model="filterText">
        </el-input>
          <el-tree 
            ref="tree"
            :data="files"
            :props="defaultProps" 
            :filter-node-method="filterNode"
            @node-click="handleNodeClick">
            <span class="custom-tree-node"  slot-scope="{ node, data }">
            <i v-if="data.isFile" :class="icon(data.type)"></i>
            <i v-else class="fa fa-folder"></i>
             {{ data.name }}
          </span>
          </el-tree>
        </el-aside>
        <el-container>
          <el-header>
            <div class="pull-right">
              <el-tooltip class="item" effect="dark" :content="$t('files.download')" placement="top">
              <el-button type="text" class="el-icon-download" @click="downloadFile"></el-button>
            </el-tooltip>
            </div>
          </el-header>
          <el-main style="padding:0px;margin:0px;">
            <iframe :src="url" style="width:100%;height:640px" frameborder="0" scrolling="auto"></iframe>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<style>
  .el-container {
    padding: 0px;
    margin: 0px;
    height: 100%;
  }
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 50px;
  }
  
  .el-aside {
    background-color: #FFFFFF;
    color: #333;
    text-align: center;
    padding: 10px;
    height:100vh;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
  }
  
  
</style>
<script>
import { Loading } from 'element-ui'

export default {
  name: 'FileFinder',
  data: function() {
  return {
    files: [],
    filterText: null,
    defaultProps: {
        children: 'children',
        label: 'name'
      },
      url: null
  }
  },
  computed: {

  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    downloadFile: function() {

    },
    icon: function(type) {
      let i = 'fa fa-file-o'
      switch(type) {
        case '.pdf':
          i = 'fa fa-file-pdf-o'
          break
        case '.xls':
        case '.xlsx':
          i = 'fa fa-file-excel-o'
          break
        case '.ppt':
        case '.pptx':
          i = 'fa fa-file-powerpoint-o'
          break
        case '.doc':
        case '.docx':
          i = 'fa fa-file-word-o'
          break
        case '.png':
        case '.jpg':
        case '.jpeg':
        case '.gif':
        case '.bmp':
          i = 'fa fa-file-photo-o'
          break
        case '.rar':
        case '.zip':
          i = 'fa fa-file-archive-o'
          break
      }
      return i
    },
    filterNode: function(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    handleNodeClick: function(node) {
      if (node.isFile) {
        this.url = this.DOC_URL + encodeURIComponent(this.STATIC_URL + 'file/' + node.path)
        console.log(this.STATIC_URL + 'file/' + node.path)
      }
    },
    loadData: function() {
    let that = this,
          query = 'userId=' + localStorage.getItem('token')
    this.$http.get(this.API3_PREFIX + 'file_finder?' + query).then(function (response) {
    that.files = response.data
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>